export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14300.e1a21273.jpg";